import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { CardItem, CardItemLoading } from './CardItem';

import { CardHeroDataProps } from '.';

export const ContentTablet: React.FC<CardHeroDataProps> = ({ isLoading, data }) => {
  const renderContent = () => {
    if (!data || isLoading) {
      return (
        <>
          <VStack>
            <CardItemLoading isLastColumn />
            <CardItemLoading />
          </VStack>
          <VStack>
            <CardItemLoading isLastColumn />
            <CardItemLoading />
          </VStack>
          <VStack>
            <CardItemLoading isLastColumn />
            <CardItemLoading />
          </VStack>
          <VStack>
            <CardItemLoading />
          </VStack>
        </>
      );
    }

    return (
      <>
        <VStack>
          <CardItem
            isLastColumn
            label={'Nome'}
            value={
              <HStack space={Spacing['inline.nano']} alignItems="center">
                <UI.Avatar
                  testId="client-avatar"
                  textColor="neutral.white"
                  bgColor={'brand.primary.light'}
                  initials={data.initials}
                />
                <UI.Text>{data.nomeCliente}</UI.Text>
              </HStack>
            }
          />
          <CardItem disabled label={'Conta sinacor'} value={data.contaSinacorComDigito} />
        </VStack>
        <VStack>
          <CardItem isLastColumn label={'E-mail'} value={data.email} />
          <CardItem label={'Conta BP'} value={data.contaBPComDigito} />
        </VStack>
        <VStack>
          <CardItem isLastColumn label={'Pessoa'} value={data.tipoPessoaNormalized} />
          <CardItem
            label={'Restrição Promocional'}
            value={
              data.promotionalRestriction.hasRestriction ? (
                <VStack space={Spacing['stack.quarck']}>
                  <UI.Text>{data.promotionalRestriction.statusText}</UI.Text>
                  <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
                    Val.{' '}
                    {Utils.Mask.DateFormat(
                      data.promotionalRestriction.blackListExpirationDate,
                      'dd/MM/yyyy'
                    )}
                  </UI.Text>
                </VStack>
              ) : (
                data.promotionalRestriction.statusText
              )
            }
          />
        </VStack>
        <VStack>
          <CardItem label={'Conta de custódia'} value={data.contaSuperPNPComDigito} />
        </VStack>
      </>
    );
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Stack
        alignContent={'center'}
        direction="row"
        borderRadius={BoxBorder.heavy}
        backgroundColor={Color.background}
        width={'100%'}
        paddingX={Spacing['inline.xxxs']}
        paddingY={Spacing['inline.xxs']}
        justifyContent={'space-between'}
        space="inline.xs">
        {renderContent()}
      </Stack>
    </UI.Shadow>
  );
};
